module.exports = __webpack_public_path__ + "static/fabrica-slide3-67e9101b5101b5e4b775b07e074a3774.jpg";